import Component from '../abstracts/Component';


export default class PasswordHelperComponent extends Component {

  static get SELECTORS() {
    return {
      main: ".js-password-helper",
      lenght: ".js-password-helper-lenght",
      style: ".js-password-helper-style",
      special: ".js-password-helper-special",
      psw_input: "#pwd",
      newPassword_input: "#newPassword",
    }
  }

  static get CLASSES() {
    return {
      text_green: "text-success",
      text_red: "text-danger",
      text_grey: "text-secondary",
    }
  }

  constructor() {
    super();
  }

  bindEvents() {
    let elements = [],
      len_check = document.querySelector(PasswordHelperComponent.SELECTORS.lenght),
      style_check = document.querySelector(PasswordHelperComponent.SELECTORS.style),
      special_check = document.querySelector(PasswordHelperComponent.SELECTORS.special),
      lowerLetterRegex = /[a-z]/,
      upperLetterRegex = /[A-Z]/,
      digitRegex = /\d/,
      specialCharactersRegex = /\W|_/;

    elements.push(document.querySelector(PasswordHelperComponent.SELECTORS.psw_input));
    elements.push(document.querySelector(PasswordHelperComponent.SELECTORS.newPassword_input));

    elements.forEach(element => {
      if (element !== null) {
        element.addEventListener('input', (event) => {
          let psw = event.target.value;

          PasswordHelperComponent.validation(len_check, psw.length >= 8 && psw.length <= 16);
          PasswordHelperComponent.validation(style_check, psw.search(lowerLetterRegex) >= 0 && psw.search(upperLetterRegex) >= 0 && psw.search(digitRegex) >= 0);
          PasswordHelperComponent.validation(special_check, !specialCharactersRegex.test(psw), true);
        });
      }
    });
  }

  static validation(element, valid, red_element = false) {
    if (valid) {
      element.classList.remove(red_element ? PasswordHelperComponent.CLASSES.text_red : PasswordHelperComponent.CLASSES.text_grey);
      element.classList.add(PasswordHelperComponent.CLASSES.text_green);
    } else {
      element.classList.remove(PasswordHelperComponent.CLASSES.text_green);
      element.classList.add(red_element ? PasswordHelperComponent.CLASSES.text_red : PasswordHelperComponent.CLASSES.text_grey);
    }
  }

  render() {
    if (document.querySelector(PasswordHelperComponent.SELECTORS.main)) this.bindEvents();
  }

}
